<template>
    <view-with-bar>
        <template slot="bar">
            <view-bar>
                <h1>{{ $t("banking.accounts")}}</h1>
                <view-bar-item route="/banking/accounts">{{ $t("banking.accountsList")}}</view-bar-item>
                <h1>{{ $t("banking.accountBalances")}}</h1>
                <view-bar-item route="/banking/account-balances">{{ $t("banking.accountBalancesList")}}</view-bar-item>
                <view-bar-item route="/banking/account-balance-items">{{ $t("banking.accountBalanceItemsList")}}</view-bar-item>
                <view-bar-item route="/banking/account-balances-blotter">{{ $t("banking.accountBalancesBlotter")}}</view-bar-item>
                <view-bar-item route="/banking/account-timelines">{{ $t("banking.accountBalanceTimelines")}}</view-bar-item>
                <h1>{{ $t("banking.reconciliation")}}</h1>
                <view-bar-item route="/banking/reconciliation-items">{{ $t("banking.reconciledItems")}}</view-bar-item>
                <view-bar-item route="/banking/reconciliation-workbench">{{ $t("banking.reconciliationWorkbench")}}</view-bar-item>
            </view-bar>
        </template>
    </view-with-bar>
</template>

<script>
    import ViewWithBar from "../components/layout/ViewWithBar";
    import ViewBar from "../components/navigation/ViewBar";
    import ViewBarItem from "../components/navigation/ViewBarItem";
    export default {
        name: "BankingView",
        components: {ViewBarItem, ViewBar, ViewWithBar}
    }
</script>

<style scoped>

</style>